import React from 'react';
import styled, { css } from 'styled-components';
import {
  flexWrap,
  flexDirection,
  alignItems,
  justifyContent,
  FlexWrapProps,
  FlexDirectionProps,
  AlignItemsProps,
  JustifyContentProps,
} from 'styled-system';
import { base, themed } from '../base';

const BoxWrapper = styled.div<
  FlexWrapProps & FlexDirectionProps & AlignItemsProps & JustifyContentProps
>(
  base,
  themed('Box'),
  css({ display: 'flex' }, flexWrap, flexDirection, alignItems, justifyContent)
);

const Box = ({ children, ...props }) => (
  <BoxWrapper {...props}>{children}</BoxWrapper>
);

export default Box;
